'use client'

import type { MouseEventHandler } from 'react'
import {
  memo,
  useCallback,
  useRef,
  useState,
} from 'react'
import { AlertOutlined, CloseOutlined, DownloadOutlined, CloudUploadOutlined, FileExcelOutlined } from '@ant-design/icons'
import { message, Button, Upload } from 'antd'
import { useHover } from 'ahooks';
import Modal from "@/components/Modal/Modal";
import { WORKFLOW_DATA_UPDATE } from './constants'
import {
  SupportUploadFileTypes,
} from './types'
import {
  initialEdges,
  initialNodes,
  formatFileSize,
  // parseXMLToFlow
} from './utils'
import cn from '@/utils/classnames'
// import {
//   importDSL,
//   importDSLConfirm,
// } from '@/service/apps'
// import { fetchWorkflowDraft } from '@/service/workflow'
// import {
//   DSLImportMode,
//   DSLImportStatus,
// } from '@/models/app'
// import Uploader from '@/app/components/app/create-from-dsl-modal/uploader'
// import Button from '@/app/components/base/button'
// import { useEventEmitterContextContext } from '@/context/event-emitter'
// import { FILE_EXTS } from '@/app/components/base/prompt-editor/constants'
// import { usePluginDependencies } from '@/app/components/workflow/plugin-dependency/hooks'

const { Dragger } = Upload;

type UpdateDSLModalProps = {
  onCancel: () => void
  onBackup: () => void
  onImport?: () => void
  onChange: (data: any) => void;
}

const UpdateDSLModal = ({
  onCancel,
  onBackup,
  onImport,
  onChange
}: UpdateDSLModalProps) => {
  // const appDetail = useAppStore(s => s.appDetail)
  const [currentFile, setDSLFile] = useState<File>()
  const [fileInfo, setFileInfo] = useState(null);
  const [fileContent, setFileContent] = useState<string>()
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(true)
  const [error, setError] = useState('');
  // const { handleCheckPluginDependencies } = usePluginDependencies()

  const ref = useRef(null);
  const isHovering = useHover(ref);
  // const { eventEmitter } = useEventEmitterContextContext();

  const readFile = (file: File) => {
    const reader = new FileReader()
    reader.onload = function (event) {
      const content = event.target?.result
      setFileContent(content as string)
    }
    reader.readAsText(file)
  }

  const handleFile = (file?: File) => {
    setDSLFile(file)
    if (file)
      readFile(file)
    if (!file)
      setFileContent('')
  }

  const handleWorkflowUpdate = useCallback(async (app_id: string) => {
    /* const {
      graph,
      features,
      hash,
    } = await fetchWorkflowDraft(`/apps/${app_id}/workflows/draft`)

    const { nodes, edges, viewport } = graph
    const newFeatures = {
      file: {
        image: {
          enabled: !!features.file_upload?.image?.enabled,
          number_limits: features.file_upload?.image?.number_limits || 3,
          transfer_methods: features.file_upload?.image?.transfer_methods || ['local_file', 'remote_url'],
        },
        enabled: !!(features.file_upload?.enabled || features.file_upload?.image?.enabled),
        allowed_file_types: features.file_upload?.allowed_file_types || [SupportUploadFileTypes.image],
        allowed_file_extensions: features.file_upload?.allowed_file_extensions || FILE_EXTS[SupportUploadFileTypes.image].map(ext => `.${ext}`),
        allowed_file_upload_methods: features.file_upload?.allowed_file_upload_methods || features.file_upload?.image?.transfer_methods || ['local_file', 'remote_url'],
        number_limits: features.file_upload?.number_limits || features.file_upload?.image?.number_limits || 3,
      },
      opening: {
        enabled: !!features.opening_statement,
        opening_statement: features.opening_statement,
        suggested_questions: features.suggested_questions,
      },
      suggested: features.suggested_questions_after_answer || { enabled: false },
      speech2text: features.speech_to_text || { enabled: false },
      text2speech: features.text_to_speech || { enabled: false },
      citation: features.retriever_resource || { enabled: false },
      moderation: features.sensitive_word_avoidance || { enabled: false },
    }

    eventEmitter?.emit({
      type: WORKFLOW_DATA_UPDATE,
      payload: {
        nodes: initialNodes(nodes, edges),
        edges: initialEdges(edges, nodes),
        viewport,
        features: newFeatures,
        hash,
      },
    } as any) */
  }, [])

  const isCreatingRef = useRef(false)

  const [parsedData, setParsedData] = useState([]);
  const [importGraph, setImportGraph] = useState<any>({});



  // 覆盖并导入
  /* const handleImport: MouseEventHandler = useCallback(async () => {
    if (isCreatingRef.current)
      return
      isCreatingRef.current = true
    if (!currentFile)
      return
    try {
      if (appDetail && fileContent) {
        setLoading(true)
        // const response = await importDSL({ mode: DSLImportMode.YAML_CONTENT, yaml_content: fileContent, app_id: appDetail.id })
        // const { id, status, app_id, imported_dsl_version, current_dsl_version } = response

        if (status === DSLImportStatus.COMPLETED || status === DSLImportStatus.COMPLETED_WITH_WARNINGS) {
         

          if (onImport)
            onImport()
          message[status === DSLImportStatus.COMPLETED ? 'success' : 'warning'](status === DSLImportStatus.COMPLETED ? '导入成功' : '注意')
          
          setLoading(false)
          onCancel()
        }
        else if (status === DSLImportStatus.PENDING) {
          setShow(false)
          setTimeout(() => {
            setShowErrorModal(true)
          }, 300)
          // setVersions({
          //   importedVersion: imported_dsl_version ?? '',
          //   systemVersion: current_dsl_version ?? '',
          // })
          // setImportId(id)
        }
        else {
          setLoading(false)
          message.error('导入失败')
        }
      }
    }
    // eslint-disable-next-line unused-imports/no-unused-vars
    catch (e) {
      setLoading(false)
      message.error('导入失败')
    }
    isCreatingRef.current = false
  }, [currentFile, fileContent, onCancel, onImport, handleWorkflowUpdate]) */

  const handleImport = async () => {
    try{
      setLoading(true);
      await setTimeout(() => {
        onCancel()
        onChange({
          type: WORKFLOW_DATA_UPDATE,
          payload: {
            nodes: initialNodes(importGraph.nodes, importGraph.edges),
            edges: initialEdges(importGraph.edges, importGraph.nodes),
            viewport: importGraph.viewport,
          },
        } as any)
        message.success('导入成功')
        setLoading(false)
      }, 400)
    /*   eventEmitter?.emit({
        type: WORKFLOW_DATA_UPDATE,
        payload: {
          nodes: initialNodes(importGraph.nodes, importGraph.edges),
          edges: initialEdges(importGraph.edges, importGraph.nodes),
          viewport: importGraph.viewport,
        },
    } as any) */
    }catch(err){
      message.error(`导入失败: ${err.message}`);
      setLoading(false)
    }
  }

  const customRequest = async (options) => {
    if (isCreatingRef.current) return
    setError('');
    isCreatingRef.current = true

    const { file, onSuccess, onError } = options;
    setLoading(true);
    try {
      const xmlString = await file.text();
      
      // 高级解析选项
      // const graph = await parseXMLToFlow(xmlString);
      const graph = JSON.parse(xmlString);
      
      // 使用防抖批量添加
      if(!graph || !graph.nodes) {
        return message.error('导入失败：文件内容格式错误');
      }

      const { nodes = [], edges=[], viewport = { x: 100, y: 0, zoom: 1 } } = graph;
      setImportGraph({viewport, nodes, edges});
      setFileInfo({
        name: file.name,
        size: file.size,
      });
      onSuccess();
    } catch (err) {
      message.error(`导入失败: ${err.message}`);
      onError(err);
    } finally {
      setLoading(false);
      isCreatingRef.current = false
    }
  };

  return (
    <>
      <Modal
        className="w-[520px] rounded-2xl p-6"
        open={show}
        onCancel={onCancel}
        footer={null}
        title={
          <div
            style={{ fontWeight: "bold", fontSize: "18px", padding: "6px 0" }}
          >
            导入 DSL
          </div>
        }
      >
        <div className="relative mb-2 flex grow gap-0.5 overflow-hidden rounded-xl border-[0.5px] border-components-panel-border bg-components-panel-bg-blur p-2 shadow-xs">
          <div className="absolute left-0 top-0 h-full w-full bg-toast-warning-bg opacity-40" />
          <div className="flex items-start justify-center p-1 pt-[2px]">
            <div className=" shrink-0 text-text-warning-secondary">
              <AlertOutlined className="h-4 w-4" />
            </div>
          </div>
          <div className="flex grow flex-col items-start gap-0.5 py-1">
            <div className="system-xs-medium whitespace-pre-line text-text-primary">
              当前草稿将被覆盖。在导入之前请导出工作流作为备份。
            </div>
            <div className="flex items-start gap-1 self-stretch pb-0.5 pt-1">
              <Button
                size="small"
                className="z-[1000]"
                onClick={onBackup}
                icon={
                  <DownloadOutlined className="h-3.5 w-3.5 text-components-button-secondary-text" />
                }
              >
                备份当前草稿
              </Button>
            </div>
          </div>
        </div>
        <div>
          <div className="system-md-semibold pt-2 text-text-primary">
            选择 DSL(json) 文件
          </div>
          <div className="w-full   py-4">
            <Dragger
              accept=".json"
              beforeUpload={(file) => {
                // 验证文件类型和大小
                const isXML = file.type === "text/json" || file.name.endsWith(".json");
                if (!isXML) {
                  message.error("只能上传JSON文件");
                  return false;
                }
                return true;
              }}
              customRequest={customRequest}
              showUploadList={false}
              className="!mt-0 w-full"
            >
              {
                fileInfo?.name ? 
                  <div ref={ref} className="flex items-center justify-start">
                    <div className="text-xl text-sky-500 pl-4 " ><FileExcelOutlined /></div>
                    <div className='grow  text-left px-2'>
                      <div className='text-black text-sm'>{fileInfo.name}</div>
                      <div className='text-gray-500 text-2xs'>XML · {formatFileSize(fileInfo.size)}</div>
                    </div>
                  </div> : 
                  <div className="flex justify-center text-gray-500 align-middle items-center gap-4 self-stretch">
                    <p className="text-xl w-4">
                      <CloudUploadOutlined className="text-gray-500" />
                    </p>
                    <p>点击或拖拽文件到这里</p>
                  </div>
              }
            </Dragger>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 self-stretch pt-5">
          <Button onClick={onCancel}>取消</Button>
          <Button
            disabled={!fileInfo?.name || loading}
            // variant='warning'
            type="primary"
            danger
            onClick={handleImport}
            loading={loading}
          >
            覆盖并导入
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default memo(UpdateDSLModal)
